import { Component } from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-industries-card',
  templateUrl: './industries-card.component.html',
  styleUrl: './industries-card.component.scss',
  imports: [
    TranslateModule,
  ],
  standalone: true
})
export class IndustriesCardComponent {

  industries = [
    {
      name: 'industries.construction',
      image: 'assets/construction.png',
      tags: [ 'industries.builder', 'industries.electrician', 'industries.site_manager' ],
    },
    {
      name: 'industries.logistics',
      image: 'assets/logistics.png',
      tags: [ 'industries.warehouse_worker', 'industries.forklift_driver', 'industries.logistics_manager' ],
    },
    {
      name: 'industries.manufacturing',
      image: 'assets/manu.png',
      tags: [ 'industries.machine_operator', 'industries.quality_control', 'industries.production_manager' ],
    },
    {
      name: 'industries.hospitality',
      image: 'assets/hospitality.png',
      tags: [ 'industries.chef', 'industries.waiter', 'industries.hotel_manager' ],
    },
    {
      name: 'industries.retail',
      image: 'assets/retail.png',
      tags: [ 'industries.sales_assistant', 'industries.cashier', 'industries.store_manager' ],
    },
    {
      name: 'industries.software',
      image: 'assets/it.png',
      tags: [ 'industries.frontend_developer', 'industries.backend_developer', 'industries.project_manager' ],
    },
  ];


}
